import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { PageDto } from './../shared';
import { ClusterDto } from './cluster/cluster.dto';

@Injectable()
export class ClustersRestService {
  private searchManagementUrl = 'api/searchManagement';
  private url = `${this.searchManagementUrl}/clusters`;

  constructor(private http: HttpClient) {}

  get(id: string, entityType: string) {
    const options = {
      params: {
        search: `entityType==${entityType};sourceEntities.id==${id}`
      }
    };

    return this.http.get<PageDto<ClusterDto>>(this.url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new ClusterDto(i));
        return page;
      })
    );
  }
}
